import React, {useEffect} from 'react';
import { useStores } from 'hooks';
import {LaneWrapper} from "./project/LaneWrapper";
import MiniDefault from "./layout/MiniDefault";
import {
    NoLanesSelected,
    NoLanesSelectedWrapper,
    NoLaneText,
    NoLaneTitle
} from "../views/BidClient/NPAMiniLayout/Styles";
import {observer} from "mobx-react-lite";
import ConnectionStatus from "./project/shared/ConnectionStatus";
import { formatDate, formatDateTimeForAPI } from 'shared/utils/dateTime';

const NoLaneSelectedMessage = ({ auctionInfo }) => {
    if (auctionInfo?.auction) {
        return (
            <NoLanesSelectedWrapper>
            <NoLanesSelected>
                <NoLaneTitle>{auctionInfo?.auction}</NoLaneTitle>
                <NoLaneText>Click a lane from the left to proceed.</NoLaneText>
            </NoLanesSelected>
            </NoLanesSelectedWrapper>
        );
    }

    return null; // Return null if no auctionInfo is provided
};

const SingleAuctionWrapper = observer(({id}) => {
    const {
        BidStore: {auction},
        AuctionStore: {
            openLanes,
            auctionInfo
        },
    } = useStores(id);

    if (!id) {
        return;
    }

    const notifications = {};
    if (openLanes.length > 0) {
        return openLanes.map((laneID) => {
            if (auction[laneID].laneName) {
                return (
                    <LaneWrapper key={laneID} laneID={laneID}>
                        <>
                            <MiniDefault
                                key={laneID}
                                auction={auction[laneID]}
                                notifications={notifications}
                                auctionId={id}
                            />
                            <ConnectionStatus auctionId={id}/>
                        </>
                    </LaneWrapper>
                )
            }
        })
    }

    return <NoLaneSelectedMessage auctionInfo={auctionInfo} />

    return (
        <>
            {openLanes.length > 0 ? (
                openLanes.map((laneID) => (
                    <LaneWrapper key={laneID} laneID={laneID}>
                        <>
                        <MiniDefault
                            key={laneID}
                            auction={auction[laneID]}
                            notifications={notifications}
                            auctionId={id}
                        />
                        <ConnectionStatus auctionId={id}  />
                        </>
                    </LaneWrapper>
                ))) : <NoLaneSelectedMessage auctionInfo={auctionInfo} /> }
        </>
    )
})

const MultiAuctionWrapper = ({auctions}) => {
    const {
        UIStore: { setLayoutViewType, layoutViewType },
    } = useStores();

    useEffect(() => {
        const layout = window.localStorage.getItem('layout');
        if (layout) {
            setLayoutViewType(layout);
        }
    }, []);

    const auctionKeys = Array.from(auctions.keys());

    return (auctionKeys.map((key, index) => {
        if (key) return <SingleAuctionWrapper key={key} id={key} auctionId={key} />
    }))
}

export default observer(MultiAuctionWrapper);
